export default __webpack_public_path__ + "static/media/samantha2.24762334.jpg";